import { useState, useEffect } from "react";

interface LiveDurationProps {
  startTime: string;
  precision: "minutes" | "seconds";
}

const formatMinutes = (startMs: number, nowMs: number): string => {
  const totalMinutes = Math.max(0, Math.floor((nowMs - startMs) / 60_000));
  const hours = Math.floor(totalMinutes / 60);
  const mins = totalMinutes % 60;
  return hours > 0 ? `${hours}h ${mins}m` : `${mins}m`;
};

const formatSeconds = (startMs: number, nowMs: number): string => {
  const totalSeconds = Math.max(0, Math.floor((nowMs - startMs) / 1_000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return minutes > 0 ? `${minutes}m ${seconds}s` : `${seconds}s`;
};

const LiveDuration = ({ startTime, precision }: LiveDurationProps) => {
  const startMs = new Date(startTime).getTime();
  const format = precision === "seconds" ? formatSeconds : formatMinutes;
  const intervalMs = precision === "seconds" ? 1_000 : 60_000;

  const [display, setDisplay] = useState(() => format(startMs, Date.now()));

  useEffect(() => {
    setDisplay(format(startMs, Date.now()));

    const id = setInterval(() => {
      setDisplay(format(startMs, Date.now()));
    }, intervalMs);

    return () => clearInterval(id);
  }, [startMs, intervalMs, format]);

  return <>{display}</>;
};

export default LiveDuration;
